var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("header"),_vm._t("body"),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }